<template>
    <div class="sa-free-page" style="height: 100%">
        <div class="sa-free-page-header">
            <b-form @submit.prevent="onSubmit">
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col cols="4">
                        <label>Identificativo</label>
                        <b-form-input v-model="filterIdentificativo" text-field="nome" value-field="nome"></b-form-input>
                    </b-col>
                    <b-col cols="4">
                        <label>Area</label>
                        <b-form-select v-model="area" :options="aree" text-field="nome" value-field="nome"></b-form-select>
                    </b-col>
                    <b-col cols="4">
                        <label>Attivita Svolte</label>
                        <b-form-checkbox v-model="filterAttivitaSvolte" name="isAttivitaSvolte" switch></b-form-checkbox>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="sa-padding-right text-right">
                        <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </div>
        <div class="sa-free-page-body">
            <b-row style="padding: 5px">
                <b-col v-for="(value, key) of pazienti" :key="key" cols="4" style="margin-top: 2px; margin-bottom: 2px">
                    <b-card header-tag="header" footer-tag="footer">
                        <template #header>
                            <b-row style="height: 50px; padding: 5px; margin-bottom: 20px">
                                <b-col style="display: flex; justify-content: start; align-items: start">
                                    <div @click="onClickAvatar(key)" style="cursor: pointer">
                                        <i class="fas fa-user-circle fa-3x"></i>
                                    </div>
                                </b-col>
                                <b-col style="display: flex; justify-content: start; align-items: center">
                                    <em style="font-weight: bold">
                                        <b-alert style="background-color: #00a3ff" show>{{ key }}</b-alert></em
                                    ></b-col
                                >
                                <b-col style="display: flex; justify-content: end; align-items: start; margin-top: 3px">
                                    <b-button size="sm" variant="outline-success" @click="onClickNuovaPianificazione(key)"> <i class="fas fa-plus"></i> </b-button
                                ></b-col>
                                <b-col cols="12" style="display: flex; justify-content: center; align-items: center">
                                    <h5>
                                        <b-badge size="large" style="background-color: #74bce5">{{ getDataFormattata(value.dataOraProgrammata) }}</b-badge>
                                    </h5>
                                </b-col>
                            </b-row>
                            <b-card-text style="height: 220px; overflow-y: scroll; overflow-x: hidden; margin-top: 2px">
                                <b-row>
                                    <b-col cols="12" v-for="(valore, chiave) in getPrestazioni(key, value)" :key="chiave" class="border rounded mb-2" style="border-color: red">
                                        <b-row class="py-1 px-3 align-items-center">
                                            <b-col class="d-flex align-items-start" style="flex: 1 1 auto; min-width: 0">
                                                <span class="text-truncate" :style="{ backgroundColor: getColorSection(valore) }"> {{ valore.nomeAttivita }} </span>-
                                                <span class="text-truncate" :style="{ backgroundColor: getColorSection(valore) }">
                                                    {{ valore.nomeAttivita }}
                                                </span>
                                            </b-col>
                                            <b-col class="d-flex justify-content-center align-items-center">
                                                {{ getDataOraFormattata(valore.dataOraProgrammata) }}
                                            </b-col>
                                            <b-col class="d-flex justify-content-end align-items-center flex-shrink-0">
                                                <b-button v-b-tooltip.hover size="sm" variant="outline-success no-text" title="Compila Scheda" :disabled="filterAttivitaSvolte" @click="onClickEseguiAttivita(valore, true)" class="mr-1 no-text">
                                                    <font-awesome-icon icon="tasks" />
                                                </b-button>
                                                <b-button v-b-tooltip.hover size="sm" variant="outline-danger no-text" title="Compila Scheda" :disabled="filterAttivitaSvolte" @click="onClickEseguiAttivita(valore, false)" class="mr-1 no-text">
                                                    <i class="far fa-times-circle"></i>
                                                </b-button>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-row>
                            </b-card-text>
                        </template>
                    </b-card>
                </b-col>
            </b-row>
            <div class="sa-free-page-footer"></div>
        </div>
        <rsa-aree-pianificazione-edit-component ref="cmpRsaAreePianificazioneEditComponent" @afterSaveRequest="onAfterSaveRequestRsaAreePianificazioneComponent"></rsa-aree-pianificazione-edit-component>
        <rsa-aree-esegui-attivita-edit-component ref="cmpRsaAreeEseguiAttivitaEditComponent" @afterSaveRequest="onAfterSaveRequestRsaAreePianificazioneComponent"></rsa-aree-esegui-attivita-edit-component>
        <b-modal :title="dynamicJsonData.titolo" ref="mdlDynamicForm" size="lg" @shown="onShownDynamicForm" @ok="onOkDynamicForm" scrollable>
            <dynamic-form ref="cmpDynamicForm" :jsonData="dynamicJsonData" :isView="false"></dynamic-form>
        </b-modal>
    </div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import moment from "moment";
import RsaAreePianificazioneEditComponent from "../../rsagestioneospiti/components/RsaAreePianificazioneEditComponent.vue";
import RsaAreeEseguiAttivitaEditComponent from "../../rsagestioneospiti/components/RsaAreeEseguiAttivitaEditComponent.vue";
import axios from "axios";
import DynamicForm from "../../../utility/components/DynamicForm.vue";

export default {
    mixins: [UtilityMixin],
    components: {
        RsaAreePianificazioneEditComponent,
        RsaAreeEseguiAttivitaEditComponent,
        DynamicForm,
    },

    data() {
        return {
            page: 1,
            filterAttivitaSvolte: false,
            perPage: 6,
            totalRow: 0,
            filterIdentificativo: "",
            key: 0,
            area: null,
            selectedArea: null,
            pathResource: "/rsaattivitapazienteschedulazioni/schedulerall",
            pathResourceArea: "/rsaaree",
            pathResourceDynamicForm: "/dynamicform",
            pathResourceDynamicFormData: null,
            items: [],
            dynamicJsonData: {},
            pazienti: {},
            pazientiAllTmp: {},
            aree: [],
            attivitaSelezionata: null,
        };
    },
    mounted() {
        this.loadDataArea();
    },
    methods: {
        onReset() {
            let me = this;
            me;
        },
        onSubmit() {
            let me = this;
            me;
        },
        onClickAvatar(key) {
            if (key) {
                let paziente = this.pazienti[key];
                if (paziente) {
                    this.$router.push("/rsapaziente/view/" + paziente.info.id);
                }
            }
        },
        onShownDynamicForm() {
            //let me = this;
            //me.$refs.cmpDynamicForm.setForm(me.defaultValues);
        },

        onOkDynamicForm(bvModalEvent) {
            let me = this;
            if (me.isDynamicFormView) {
                me.$refs.mdlDynamicForm.hide();
            } else {
                let responseJsonData = this.$refs.cmpDynamicForm.getJsonData();
                responseJsonData.idAccettazione = me.attivitaSelezionata.idAccettazione;
                responseJsonData.idPaziente = me.attivitaSelezionata.idPaziente;
                responseJsonData.dataOraPrevista = me.attivitaSelezionata.dataOraPrevista;
                responseJsonData.dataOraEffettuata = me.attivitaSelezionata.dataOra;
                responseJsonData.dataOra = me.attivitaSelezionata.dataOra;
                responseJsonData.idRsaAttivitaPazienteSchedulazione = me.attivitaSelezionata.idRsaAttivitaPazienteSchedulazione;
                responseJsonData.nomeAttivita = me.attivitaSelezionata.nomeAttivita;
                responseJsonData.dettaglio = me.attivitaSelezionata.dettaglio;
                responseJsonData.indicazioni = me.attivitaSelezionata.indicazioni;
                responseJsonData.idAttivita = me.attivitaSelezionata.idAttivita;
                responseJsonData.idForm = me.dynamicJsonData.id;
                responseJsonData.dataOra = new Date().getTime();
                responseJsonData.note = " ";
                delete responseJsonData.ospite;
                delete responseJsonData.dataNascita;
                delete responseJsonData.educatore;
                delete responseJsonData.numero;
                //delete responseJsonData.dataOra;
                bvModalEvent.preventDefault();
                me.creaAttivita(responseJsonData);
            }
        },
        creaAttivita(responseJsonData) {
            let me = this;
            me.$refs.cmpModalLoading.show();
            let link = process.env.VUE_APP_PATH_API + me.pathResourceDynamicFormData;
            axios
                .post(link, responseJsonData)
                .then(() => {
                    me.$emit("afterSaveRequest");

                    me.$refs.mdlDynamicForm.hide();
                    me.$refs.cmpModalLoading.close();
                })
                .catch((error) => {
                    me.$emit("afterSaveRequest");
                    let messaggio = "Errore non gestito";
                    if (error.response) {
                        if (error.response.data.messaggio) {
                            messaggio = error.response.data.messaggio;
                        } else {
                            messaggio = error.response.data;
                        }
                    }
                    this.$bvModal
                        .msgBoxOk(messaggio, {
                            title: "ATTENZIONE",
                            size: "sm",
                            okVariant: "outline-danger",
                            headerBgVariant: "danger",
                            centered: true,
                        })
                        .then(() => {})
                        .catch((err) => {
                            err;
                        });
                    me.$refs.cmpModalLoading.close();
                });
        },
        onClickEseguiAttivita(item, esito) {
            let me = this;
            let returnValue = esito ? "ESEGUITA" : "NON ESEGUITA";
            me.attivitaSelezionata = item;
            if (item.idForm && esito) {
                UtilityMixin.methods.loadDataResources(me.pathResourceDynamicForm + "/" + item.idForm, {}, me.loadDynamicFormSuccess, me.loadDynamicFormError);
            } else {
                if (item.rsaAttivitaPazienteBean === null) {
                    item.dataOraEffettuata = new Date().getTime();
                }
                me.$refs.cmpRsaAreeEseguiAttivitaEditComponent.add(item, returnValue);
            }
        },
        loadDynamicFormSuccess(response) {
            let me = this;
            let dynamicJsonData = response.data.data;
            dynamicJsonData.jsonForm = JSON.parse(response.data.data.jsonForm);
            me.dynamicJsonData = dynamicJsonData;
            me.pathResourceDynamicFormData = dynamicJsonData.pathModule;
            me.$refs.mdlDynamicForm.show();
        },
        loadDynamicFormError(error) {
            console.log(error);
        },
        onAfterSaveRequestRsaAreePianificazioneComponent() {
            let me = this;
            me.loadDataArea();
        },
        getPrestazioni(key, array) {
            let me = this;

            // console.log(key, array);

            let prestazioni = array[this.area];
            let result = {};
            if (prestazioni) {
                if (!me.filterAttivitaSvolte) {
                    result = prestazioni.filter((e) => e.stato == "PROGRAMMATA");
                } else {
                    result = prestazioni.filter((e) => e.stato != "PROGRAMMATA");
                }
            }
            return result;
        },

        getColorSection(value) {
            let color = "rgba(255, 247, 173, 0.98)";
            switch (value.stato) {
                case "ESEGUITA":
                    color = "#2CC28E";
                    break;
                case "NON ESEGUITA":
                    color = "#FEC2C2";
                    break;

                default:
                    break;
            }
            return color;
        },
        loadSchedulerForArea() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResource, {}, me.loadSchedulerForAreaSuccess, me.loadSchedulerForAreaError);
        },
        loadSchedulerForAreaSuccess(response) {
            let me = this;
            let items = response.data.data;
            me.setPazientiAttivita(items);
        },
        loadSchedulerForAreaError(error) {
            console.log(error);
        },
        getDataFormattata(date) {
            let data = moment(date).format("DD/MM/YYYY");
            return data;
        },
        getDataOraFormattata(date) {
            let data = moment(date).format("HH:mm");
            return data;
        },

        onChangeAreaSelected(value) {
            console.log(value);
        },
        setPazientiAttivita(items) {
            let pazienti = {};
            for (let item of items) {
                if (item.identificativo) {
                    if (pazienti[item.identificativo]) {
                        if (!pazienti[item.identificativo][item.area]) {
                            pazienti[item.identificativo][item.area] = [];
                        }
                        pazienti[item.identificativo][item.area].push(item);
                    } else {
                        pazienti[item.identificativo] = {
                            info: {
                                id: item.idPaziente,
                                idAccettazione: item.idAccettazione,
                            },
                        };
                    }
                }
            }
            this.pazienti = pazienti;
        },

        loadDataArea() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceArea, {}, me.loadDataAreaSuccess, me.loadDataAreaError);
        },
        loadDataAreaSuccess(response) {
            let me = this;
            me.aree = [];
            for (let item of response.data.data.list) {
                me.aree.push({ nome: item.nome, id: item.id });
            }
            this.loadSchedulerForArea();
            if (me.aree.length > 0) {
                me.area = me.aree[0].nome;
            }
        },
        loadDataAreaError(error) {
            console.log(error);
        },
        onClickNuovaPianificazione(key) {
            let me = this;
            let area = this.area;
            me.$refs.cmpRsaAreePianificazioneEditComponent.edit(
                {
                    id: null,
                    nomeAttivita: null,
                    dataInizio: new Date().getTime(),
                    dataFine: null,
                    listaOrari: [{ dataInizio: new Date().getTime(), giorni: null, orari: null }],
                    idAccettazione: this.pazienti[key].info.idAccettazione,
                    idPaziente: this.pazienti[key].info.id,
                    area: me.area,
                    dettaglio: "ATTIVITA EXTRA",
                },
                area
            );
        },
    },
    watch: {},
};
</script>

<style lang="scss" scoped></style>
